import { ColumnSetting } from '../../../../_foundation/models/grid.models';

export const columns: ColumnSetting[] = [
  {
    field: 'activityTypeName',
    title: 'Activity',
    filter: 'text'
  },
  {
    field: 'showStartDate',
    title: 'Start Time',
    filter: 'date'
  },
  {
    field: 'showEndDate',
    title: 'End Time',
    filter: 'date'
  },
  {
    field: 'showLastModifiedDate',
    title: 'Last Updated',
    filter: 'date'
  },
  {
    field: 'lastModifiedBy',
    title: 'Last Updated By',
    filter: 'text'
  },
  {
    field: 'activityStatusName',
    title: 'Status',
    filter: 'text'
  },
  {
    field: 'actions',
    title: '',
    filterable: false,
    width: 300
  }
];



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v1/jacking-activity-list-component/jacking-activity-list-component.config.ts